/* Pétale Paris — parcours d'achat en 3 étapes : état de l'étape 2 (photo et/ou gravure) et sélection du packaging.
   Bijoux photo : l'étape 2 est validée quand la photo est envoyée (Mighty Image Uploader).
   Bijoux gravés : les champs de gravure de Hulk Product Options sont replacés dans l'étape 2
   (juste avant le bloc d'aide « pp-gravure-help ») et l'étape est validée quand les champs obligatoires sont remplis. */
(function () {
  function setup(form) {
    if (form.dataset.ppEtapes) return;
    form.dataset.ppEtapes = '1';

    var step = form.querySelector('.pp-step--2');
    var tag = step ? step.querySelector('em') : null;
    var tagDefault = tag ? tag.textContent : '';
    var tagLoading = 'Envoi…';

    function hulkBox() {
      return form.querySelector('[id^="hulkapps_custom_options_"]');
    }

    /* Replace le bloc Hulk dans l'étape 2. Hulk réaffiche ses champs dans ce même bloc (repéré par son id). */
    function placeHulk() {
      var box = hulkBox();
      var anchor = form.querySelector('.pp-gravure-help');
      if (!box || !anchor || box.nextElementSibling === anchor) return;
      anchor.parentNode.insertBefore(box, anchor);
      box.classList.add('pp-gravure-champs');
    }

    /* Le bloc des délais (snippet pp-apres-panier) est placé en bas du cadre de l'étape 2 (bijoux photo et gravés). */
    function placeDelais() {
      var help = form.querySelector('.pp-gravure-help') || form.querySelector('.pp-photo-help');
      var d = document.getElementById('pp-delais');
      if (!help || !d || d.parentNode === help) return;
      d.classList.remove('stl-wrap--sous-offres');
      d.classList.add('pp-delais-etape');
      help.appendChild(d);
    }

    /* Photo de la carte (templates bijou-gravure / bijou-personnalise uniquement) : l'uploader Mighty de la configuration
       « Photo carte » (facultatif, tag « gravure ») est placé sous le message de la carte et affiché seulement si la carte
       est cochée (CSS .pp-carte-photo). Il ne compte pas comme la photo obligatoire de l'étape 2.
       L'uploader photo obligatoire (configuration « Votre Image », tag « photo », ex. le médaillon) n'est pas concerné. */
    var ppView = (document.querySelector('script[data-pp-view]') || { getAttribute: function () { return ''; } }).getAttribute('data-pp-view') || '';
    var carteView = /^bijou-(gravure|personnalise)$/.test(ppView);
    var CARTE_PHOTO = /^properties\[_?Photo carte/;
    function placeCartePhoto() {
      if (!carteView) return;
      var s = ((window.imageUploader || {}).settings || []).filter(function (x) { return x.uploadConfig && x.uploadConfig.customImageLabel === 'Photo carte'; })[0];
      var c = s && form.querySelector('#ImageUploaderContainer[data-setting-id="' + s._id + '"]');
      var z = c && (c.closest('.shopify-app-block') || c);
      var anchor = form.querySelector('.pp-carte-msg');
      if (!z || !anchor) return;
      z.classList.add('pp-carte-photo');
      if (anchor.nextElementSibling !== z) anchor.parentNode.insertBefore(z, anchor.nextSibling);
    }
    /* Carte décochée : la photo de la carte n'est pas envoyée (le champ perd son nom, comme le message). */
    function syncCartePhoto() {
      if (!carteView) return;
      var cb = form.querySelector('.pp-packaging toggle-cross-sell:nth-child(2) input[type="checkbox"]');
      var on = !!(cb && cb.checked);
      document.querySelectorAll('#ImageAttributeContainer input').forEach(function (i) {
        if (CARTE_PHOTO.test(i.name || i.dataset.ppName || '')) {
          if (i.name) i.dataset.ppName = i.name;
          i.name = on ? i.dataset.ppName : '';
        }
      });
    }
    /* Uploader(s) de l'étape 2, hors photo de la carte. */
    function mainUp(sel) {
      return Array.prototype.some.call(form.querySelectorAll(sel), function (el) { return !el.closest('.pp-carte-photo'); });
    }

    function zone() {
      var c = form.querySelector('#ImageUploaderContainer');
      return c ? c.closest('.shopify-app-block') || c : null;
    }

    function photoMode() {
      return mainUp('#ImageUploader .upload-button');
    }

    function isLoading() {
      return mainUp('#ImageUploader .picture-card-loading-wrapper');
    }

    function hasPhoto() {
      var inputs = form.querySelectorAll('#ImageAttributeContainer input[name^="properties"]');
      for (var i = 0; i < inputs.length; i++) {
        if (/^https?:/i.test(inputs[i].value || '')) return true;
      }
      return !isLoading() && !!form.querySelector('#ImageUploader .picture-card-image img');
    }

    function hulkOptions() {
      var box = hulkBox();
      var opts = box ? Array.prototype.slice.call(box.querySelectorAll('.hulkapps_option')) : [];
      /* Champs de gravure natifs du thème (bloc « Champ produit personnalisé »), hors message de la carte personnalisée. */
      opts = opts.concat(Array.prototype.slice.call(form.querySelectorAll('.custom-product-field:not(.pp-carte-msg)')));
      return opts.filter(function (o) {
        return o.offsetParent !== null;
      });
    }

    function isRequired(o) {
      return o.classList.contains('required') || !!o.querySelector('[required]');
    }

    function filled(o) {
      var fields = o.querySelectorAll('input:not([type="hidden"]), select, textarea');
      if (!fields.length) return true;
      return Array.prototype.some.call(fields, function (f) {
        if (f.type === 'radio' || f.type === 'checkbox') return f.checked;
        return (f.value || '').trim() !== '';
      });
    }

    /* Champs obligatoires dans Hulk : tous doivent être remplis. Sinon : au moins un champ rempli. */
    function hulkFilled() {
      var opts = hulkOptions();
      if (!opts.length) return true;
      var req = opts.filter(isRequired);
      return req.length ? req.every(filled) : opts.some(filled);
    }

    function needs() {
      return photoMode() || hulkOptions().length > 0;
    }

    function isDone() {
      if (!needs()) return false;
      if (photoMode() && !hasPhoto()) return false;
      return hulkFilled();
    }

    var last = null;
    function refresh() {
      placeHulk();
      placeDelais();
      placeCartePhoto();
      syncCartePhoto();
      var ok = isDone();
      var state = ok ? 'done' : isLoading() ? 'loading' : 'empty';
      if (state === last) return;
      last = state;
      if (step) {
        step.classList.toggle('is-done', ok);
        step.classList.toggle('is-loading', state === 'loading');
      }
      form.classList.toggle('pp-photo-done', ok);
      if (state !== 'empty') form.classList.remove('pp-photo-missing');
      var tagDone = (hulkBox() || form.querySelector('.custom-product-field')) && !photoMode() ? 'Complétée' : 'Ajoutée';
      if (tag) tag.textContent = ok ? tagDone : state === 'loading' ? tagLoading : tagDefault;
    }

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; refresh(); });
    }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class', 'src', 'style'] });
    form.addEventListener('change', refresh);
    form.addEventListener('submit', syncCartePhoto, true); /* juste avant l'envoi au panier */
    form.addEventListener('input', function () { last = null; refresh(); });
    refresh();

    /* Clic sur « Ajouter au panier » avec l'étape 2 incomplète : on ramène l'attention sur l'étape 2. */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="add"], [data-ref="add-to-cart-button"]');
      if (!btn || !needs() || isDone() || isLoading()) return;
      var z = step || zone() || hulkBox();
      if (!z) return;
      form.classList.remove('pp-photo-missing');
      void form.offsetWidth;
      form.classList.add('pp-photo-missing');
      var r = z.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight) {
        z.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);

    /* « Sans coffret » décoche le coffret (1er produit du bloc d'options), pas la carte personnalisée. */
    var none = form.querySelector('.pp-pack-none');
    if (none) {
      none.setAttribute('role', 'button');
      none.setAttribute('tabindex', '0');
      var clear = function () {
        form.querySelectorAll('.pp-packaging toggle-cross-sell:first-child input[type="checkbox"]').forEach(function (cb) {
          if (cb.checked) {
            cb.checked = false;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      };
      none.addEventListener('click', clear);
      none.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); clear(); }
      });
    }

    /* Carte personnalisée (2e produit du bloc d'options) : suggestions cliquables au-dessus du message.
       Le message n'est envoyé que si la carte est cochée et le message rempli (sinon le champ perd son nom). */
    var carte = form.querySelector('.pp-carte-msg');
    var msg = carte && carte.querySelector('input');
    if (msg) {
      var msgName = msg.name;
      msg.setAttribute('aria-label', 'Message carte'); /* libellé visible masqué en CSS */
      var sync = function () {
        var cb = form.querySelector('.pp-packaging toggle-cross-sell:nth-child(2) input[type="checkbox"]');
        msg.name = cb && cb.checked && msg.value.trim() ? msgName : '';
      };
      var chips = document.createElement('div');
      chips.className = 'pp-carte-chips';
      [
        "Joyeux anniversaire, mon amour.",
        "Toi et moi, pour toujours.",
        "Mon cœur t'appartient, aujourd'hui et pour toujours.",
        "À nous deux, et à tous les jours qui restent à écrire.",
        "Pour que son sourire t'accompagne partout.",
        "Bonne fête maman, merci pour tout.",
        "Bonne fête mamie, on t'aime fort.",
        "Bonne fête papa, mon premier héros.",
        "Merci d'être toujours là."
      ].forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = t;
        b.addEventListener('click', function () { msg.value = t; msg.dispatchEvent(new Event('input', { bubbles: true })); });
        chips.appendChild(b);
      });
      carte.insertBefore(chips, msg.parentNode);
      form.addEventListener('input', sync);
      form.addEventListener('change', sync);
      form.addEventListener('click', function () { setTimeout(sync); });
      sync();
    }

    /* Carte personnalisée : un clic sur sa vignette (étape 3) ouvre un aperçu en grand (visuel principal puis exemple de carte)
       au lieu de cocher la carte. Le reste de la tuile coche/décoche la carte comme avant. Images lues dans /products/carte-personnalisee.js. */
    var vignette = form.querySelector('.pp-packaging toggle-cross-sell:nth-child(2) .toggle-cross-sell__product-image');
    if (vignette) {
      var lienCarte = vignette.querySelector('a');
      var urlCarte = (lienCarte && lienCarte.getAttribute('href') || '/products/carte-personnalisee').split('?')[0];
      vignette.setAttribute('role', 'button');
      vignette.setAttribute('tabindex', '0');
      vignette.setAttribute('aria-label', 'Voir la carte en grand');
      var apercu = null;
      var montrer = function () { apercu.showModal(); document.documentElement.style.overflow = 'hidden'; };
      var ouvrirApercu = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (apercu) { montrer(); return; }
        fetch(urlCarte + '.js').then(function (r) { return r.json(); }).then(function (p) {
          /* Visuel principal d'abord, exemple de carte (texte alternatif « Exemple… ») ensuite. */
          var medias = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).sort(function (a, b) {
            return (/^exemple/i.test(a.alt || '') ? 1 : 0) - (/^exemple/i.test(b.alt || '') ? 1 : 0);
          });
          apercu = document.createElement('dialog');
          apercu.className = 'pp-carte-apercu';
          apercu.setAttribute('aria-label', 'Aperçu de la carte personnalisée');
          var croix = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
          var fleche = function (d) { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
          apercu.innerHTML = '<button type="button" class="pp-carte-apercu__fermer" aria-label="Fermer">' + croix + '</button><div class="pp-carte-apercu__piste"></div>' +
            (medias.length > 1 ? '<button type="button" class="pp-carte-apercu__nav pp-carte-apercu__nav--prec" aria-label="Image précédente">' + fleche('M15 5l-7 7 7 7') + '</button><button type="button" class="pp-carte-apercu__nav pp-carte-apercu__nav--suiv" aria-label="Image suivante">' + fleche('M9 5l7 7-7 7') + '</button>' : '');
          var piste = apercu.querySelector('.pp-carte-apercu__piste');
          medias.forEach(function (m) {
            var img = document.createElement('img');
            img.src = m.src + (m.src.indexOf('?') > -1 ? '&' : '?') + 'width=1080';
            img.alt = m.alt || '';
            img.width = 1080;
            img.height = 1080;
            piste.appendChild(img);
          });
          var fermer = function () { apercu.close(); };
          apercu.querySelector('.pp-carte-apercu__fermer').addEventListener('click', fermer);
          apercu.addEventListener('click', function (ev) { if (ev.target === apercu) fermer(); }); /* clic sur le fond */
          apercu.querySelectorAll('.pp-carte-apercu__nav').forEach(function (b) {
            b.addEventListener('click', function () {
              var sens = b.classList.contains('pp-carte-apercu__nav--suiv') ? 1 : -1;
              piste.scrollBy({ left: sens * piste.clientWidth, behavior: 'smooth' });
            });
          });
          apercu.addEventListener('close', function () { document.documentElement.style.overflow = ''; vignette.focus(); });
          document.body.appendChild(apercu);
          montrer();
        }).catch(function () { if (lienCarte) window.location.href = urlCarte; });
      };
      vignette.addEventListener('click', ouvrirApercu);
      vignette.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') ouvrirApercu(e); });
    }
  }

  /* Le thème recharge le sélecteur de finition sans préciser le template : on le lui redonne,
     sinon l'affichage bascule sur celui du template par défaut après un changement de finition. */
  function keepTemplate(form) {
    var tag = document.querySelector('script[data-pp-view]');
    var view = (tag && tag.getAttribute('data-pp-view')) || new URLSearchParams(window.location.search).get('view');
    var picker = form.querySelector('variant-picker');
    if (!view || !picker || picker.ppKeepTemplate) return;
    picker.ppKeepTemplate = true;
    picker.buildRequestUrl = function () {
      var url = Object.getPrototypeOf(this).buildRequestUrl.call(this);
      if (/[?&]view=/.test(url)) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=' + encodeURIComponent(view);
    };
  }

  function init() {
    document.querySelectorAll('.product-form__form').forEach(function (form) {
      if (!form.querySelector('.pp-step')) return;
      keepTemplate(form);
      setup(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
